import { Link, useLocation } from 'react-router-dom';
import ModalImage from "react-modal-image";

import projects from './projects-data';
import './Project.css';


const ProjectNotFound = () => {
    return (
        <section className="relative py-20 md:pt-32">
            <picture className="pointer-events-none absolute inset-0 -z-10">
                <img src="img/gradient_dark.jpg" alt="gradient dark" className="h-full w-full" />
            </picture>
            <div className="container">
                <div className="mx-auto max-w-lg text-center">
                    <img src="img/404.png" alt="404" className="mb-16 inline-block" />
                    <h1 className="mb-6 font-display text-4xl text-khi-700 dark:text-white md:text-6xl">Project Not Found!</h1>
                    <p className="mb-12 text-lg leading-normal dark:text-khi-300">
                        Oops! The project you are looking for does not exist.
                    </p>
                    <Link to="/projects" className="inline-block rounded-full bg-accent py-3 px-8 text-center font-semibold text-white shadow-accent-volume transition-all hover:bg-accent-dark">Navigate Back Projects</Link>
                </div>
            </div>
        </section>
    )
}
const ProjectImages = ({ images }) => {
    return (
        <div className="grid grid-cols-1 gap-[1.875rem] md:grid-cols-2 lg:grid-cols-3">
            {
                images.map(entry => {
                    return (
                        <div className="project-container" key={entry.id}>
                            <div className="project-card block rounded-2.5xl border border-khi-100 bg-white p-[1.1875rem] transition-shadow hover:shadow-lg dark:border-khi-700 dark:bg-khi-700">
                                <ModalImage
                                    small={entry.path}
                                    large={entry.path}
                                    alt="Project Image"
                                    className="project-img-main w-full rounded-[0.625rem]"
                                />
                            </div>
                        </div>
                    )
                })
            }
        </div>
    )
}
function Project() {
    const location = useLocation();
    const { state } = location;
    const { projectId } = state;

    const project = projects.find(project => project.id === projectId);
    if (!project) {
        return <ProjectNotFound />
    }

    const mainImageURL = `img/projects/${project.id}/main.${project.hasOwnProperty('imagesMimeType') ? project.imagesMimeType : 'jpg'}`;

    const images = [];
    if (project.hasOwnProperty('images')) {
        for (let i = 1; i <= project.images; i++) {
            const ext = project.hasOwnProperty('imagesMimeType') ? project.imagesMimeType : 'jpg';
            images.push({
                id: `project-${project.id}-img-${i}`,
                path: `img/projects/${project.id}/${i}.${ext}`
            });
        }
    }
    return (
        <main className="mt-24">
            <section className="relative pt-12 pb-24 lg:py-24">
                <div className="container">
                    <div className="md:flex md:flex-wrap">
                        <figure className="mb-8 md:w-2/5 md:flex-shrink-0 md:flex-grow-0 md:basis-auto lg:w-1/2">
                            <ModalImage
                                small={mainImageURL}
                                large={mainImageURL}
                                alt="Main Image"
                                className="rounded-2.5xl"
                            />
                        </figure>
                        <div className="md:w-3/5 md:basis-auto md:pl-8 lg:w-1/2 lg:pl-[3.75rem]">
                            <h1 className="mb-4 font-display text-4xl font-semibold text-khi-700 dark:text-white">{project.name}</h1>
                            <div className="project-desc-container">
                                <p className="mb-10 dark:text-khi-300" dangerouslySetInnerHTML={{ __html: project.desc }}></p>
                            </div>
                        </div>
                    </div>
                    <ProjectImages images={images} />
                </div>
            </section>
        </main>
    )
}

export default Project